import React from 'react';
import Bullying2024 from 'views/Bullying2024';
const BridgeCoursePage = () => {
  return <Bullying2024/>;
};

export default BridgeCoursePage;